const checkout = {
  secure: 'Secure checkout',
  selectedPlan: 'Selected plan',
  tagline: 'Launch faster with confidence',
  subTagline: 'Everything you need to onboard and scale securely.',
  bullet1: 'Start building with a secure, fast API platform.',
  bullet2: 'Transparent pricing with predictable renewals.',
  bullet3: 'Priority support to help you launch faster.',
  title: 'Checkout',
  description: 'Select your plan, share your details, and finish in two steps.',
  loadError: 'Unable to load checkout info.',
  stepCustomer: 'Customer',
  stepPayment: 'Payment',
  contact: 'Contact information',
  additionalFields: 'Additional details',
  billingAddressTitle: 'Billing address',
  contactDetailsTitle: 'Contact details',
  email: 'Email',
  emailPlaceholder: 'you@example.com',
  plan: 'Choose a plan',
  package: 'Choose a credit package',
  plansToggle: 'Plans',
  packagesToggle: 'Credit packages',
  recommended: 'Recommended',
  freeTrialLabel: '{{count}}-day free trial',
  noCardRequired: 'No card required',
  individualPlans: 'Individual plans',
  individualPlansHelper: 'For personal accounts and solo builders',
  teamPlans: 'Team plans',
  teamPlansHelper: 'For workspaces that need shared access',
  noPlansForType: 'No plans available for this audience yet.',
  noPackagesForType: 'No credit packages available for this audience yet.',
  switchPlanType: 'Try switching between individual and team plans.',
  noPricingForPlan: 'No pricing options configured for this plan.',
  noPackagePricing: 'No pricing options configured for this package.',
  packageCredits: '{{credits}} credits',
  includedSeatsLabel: 'Included seats',
  includedSeatsValue: '{{count}} seats',
  includedSeatsInline: 'Includes {{count}} seats',
  features: 'Included features',
  moreFeatures: 'more features',
  teamHeading: 'Team ownership',
  teamSubheading: 'Assign a workspace owner and name the team.',
  teamBadge: 'Teams',
  roleIndividual: 'Individual',
  roleTeamOwner: 'Team owner',
  teamName: 'Workspace name',
  workspaceNameRequired: 'Workspace name is required.',
  teamNamePlaceholder: 'e.g., Acme Platform Team',
  haveAccount: 'Already have an account?',
  continue: 'Continue',
  review: 'Review',
  verificationPending: 'Please verify your email to finish.',
  stepLabel: 'Step 2 of 2',
  noPlan: 'No plan',
  billing: 'Billing',
  introSummary: 'Intro: {{introPrice}} for {{cycles}} billing cycles, then {{recurringPrice}} {{cycleSuffix}}',
  cycleSuffixMonthly: 'per month',
  cycleSuffixYearly: 'per year',
  cycleSuffixEveryMonths: 'per {{count}} months',
  billingCycles: {
    monthly: 'Monthly',
    monthlyBilling: 'Monthly billing',
    yearly: 'Yearly',
    yearlyBilling: 'Yearly billing',
    annual: 'Annual',
  },
  termsLabelPrefix: 'I agree to the',
  termsLabelSuffix: '',
  termsRequired: 'You must agree to the Terms of Service to continue.',
  requiredField: 'This field is required.',
  phoneInvalid: 'Enter a valid phone number.',
  companyTooLong: 'Company name must be 255 characters or less.',
  verifyPrompt: 'Check your email to verify your account.',
  verifyBody: 'We sent a verification email to complete your signup. Follow the link in your inbox.',
  back: 'Back',
  goToLogin: 'Go to login',
  totalDue: 'Total cost',
  paymentNext: 'Payment required. Continue with the provided instructions.',
  noPaymentNow: 'No payment required.',
  complete: 'Continue',
  paymentRequired: 'Checkout created. Continue to payment.',
  completed: 'Signup completed successfully.',
  successTitle: 'Checkout complete',
  successSubtitle: '',
  paymentRequiredTitle: 'Payment required',
  paymentRequiredBody: 'Follow the payment instructions to finish your checkout.',
  paymentDetails: 'Payment details',
  paymentUnavailable: 'Stripe is not configured for this checkout. Please contact support.',
  paymentError: 'Payment failed. Please review your details and try again.',
  alreadyRegistered: 'You already have an account. Log in to continue.',
  payNow: 'Pay now',
  processingPayment: 'Processing payment...',
  trialCardNotice: 'No charge today; your card will be saved for renewal.',
  supportDetails: 'Support details',
  paymentIntentId: 'Payment intent',
  subscriptionId: 'Subscription',
  setupIntentId: 'Setup intent',
  error: 'Unable to complete checkout.',
  selectionMissing: 'Please select a plan or credit package to continue.',
  noPricing: 'No pricing available for this plan. Please select another plan.',
  selectedPackage: 'Selected package',
  packageSummary: 'Package',
  noPackage: 'No package',
  creditsLabel: 'Credits',
  creditsValue: '{{credits}} credits',
  default: 'Default',
  teams: 'Teams',
  fields: {
    company: 'Company',
    contact_phone: 'Phone',
    billing: {
      address_line_1: 'Street address',
      address_line_2: 'Address line 2',
      address_city: 'City',
      address_state: 'State or region',
      address_postal_code: 'Postal code',
      address_country: 'Country',
    },
  },
  placeholders: {
    company: 'Acme Inc.',
    contact_phone: '+1 555 123 4567',
    billing: {
      address_line_1: 'Street address',
      address_line_2: 'Apartment, suite, etc.',
      address_city: 'City',
      address_state: 'State/Region',
      address_postal_code: 'Postal code',
      address_country: 'Country code (e.g., US)',
    },
  },
} as const;

export default checkout;
